var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 7.24997V0.375H21.6249V7.24997H12.5625ZM0.375 11.6249V0.375H9.43744V11.6249H0.375ZM12.5625 21.6249V10.375H21.6249V21.6249H12.5625ZM0.375 21.6249V14.75H9.43744V21.6249H0.375ZM2.24997 9.74997H7.5625V2.24997H2.24997V9.74997ZM14.4374 19.75H19.75V12.25H14.4374V19.75ZM14.4374 5.375H19.75V2.24997H14.4374V5.375ZM2.24997 19.75H7.5625V16.6249H2.24997V19.75Z",
    fill: "#00AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.d8b4902b16efc4f15c7de474d4fb270b.svg";
export { ForwardRef as ReactComponent };